import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

import {
  Employee,
  EditEmployee,
  EditRoleType,
  EditUser,
  RoleType,
  Users,
} from '../views/Management';
import { HomeNavbar } from '../components/Nevbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import { NotFound } from '../components/Error';
// import accessRight from '../utils/functions/accessRight';
import * as actions from '../redux/actions';

export function Management() {
  const module = 'MANAGEMENT';
  const prefix = '/management';
  const name = 'ตั้งค่าระบบ';
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const me = useSelector((state) => state.me);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  return (
    <div className="min-h-screen">
      <MainSidebar
        onMobileClose={handleOnMobileNavClose}
        openMobile={isMobileNavOpen}
        me={me}
      />
      <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />

      <div className="relative lg:ml-64  min-h-screen   px-8 ">
        <div className="py-4">
          <Switch>
            <Route exact path={`/`}>
              <Employee title="จัดการพนักงาน" subtitle={name} />
            </Route>

            <Route exact path={`${prefix}/employee`}>
              <Employee title="จัดการพนักงาน" subtitle={name} />
            </Route>

            <Route exact path={`${prefix}/employee/edit/:id`}>
              <EditEmployee title="แก้ไขพนักงาน" subtitle={name} />
            </Route>

            <Route exact path={`${prefix}/user/`}>
              <Users title="จัดการผู้ใช้งาน" subtitle={name} />
            </Route>

            <Route exact path={`${prefix}/user/edit/:id`}>
              <EditUser title="แก้ไขผู้ใช้งาน" subtitle={name} />
            </Route>

            <Route exact path={`${prefix}/role-type/`}>
              <RoleType title="จัดการบทบาท" subtitle={name} />
            </Route>

            <Route exact path={`${prefix}/role-type/edit/:id`}>
              <EditRoleType title="แก้ไขบทบาท" subtitle={name} />
            </Route>

            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </div>
      </div>
      <div className="lg:ml-64">
        <MainFooter />
      </div>
    </div>
  );
}

export default Management;
